import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td ,filter} from "@chakra-ui/react";
import { TopDisplay, SearchForm} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo} from "react";
import styled from "@emotion/styled";
import { LuDownload as DownIcon } from "react-icons/lu";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { format } from "date-fns";
import {useAtom,atom} from 'jotai'
import { Loader} from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import apiCall from "../../../utils/apiCall";
import { Formik,Form,Field } from "formik";
import apiCallFormData from '../../../utils/apiFormDataCall';
import * as Yup from 'yup';
import DateFilter from "../../../components/DateFilter";
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { downloadApi } from "../../../api";

const indexAtom = atom<number | null>(null);

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`


  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
   
`

interface TransactionItem {
  PaymentHistoryId: number;
  PaymentReference?: string | null;
  MerchantReference?: string | null;
  ApplicantId?: string | number | null;
  FullName?: string | null;
  PaymentChannel?: string | null;
  CustomerPhone?: string | null;
  CustomerEmail?: string | null;
  PaymentDate?: string | null;
  Amount?: number | string | null;
  PaymentAction?: string | null;
  PaymentStatus?: string | null;
}

export default function TransactionHistory() {
  const [hide, set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);

  // 🔹 Filters
  const [selectedPaymentChannel, setSelectedPaymentChannel] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedPaymentAction, setSelectedPaymentAction] = useState("Exam");

  const [dateRange, setDateRange] = useState(() => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 3);
    return {
      startDate: start.toISOString().split("T")[0],
      endDate: end.toISOString().split("T")[0]
    };
  });

  const [search, setSearch] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState<TransactionItem[]>([]);

  const paymentActionList = ["Exam Fee", "Exam Subscription", "Exam Induction", "Exam Transcript"];

  // 🔹 Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 100;

  // 🔹 API Fetch Function
  const fetchTransactions = async () => {
    const params = new URLSearchParams();

    params.append("PageNumber", pageNumber.toString());
    params.append("PageSize", pageSize.toString());

    params.append("paymentAction", selectedPaymentAction);

    if (selectedPaymentChannel) params.append("paymentChannel", selectedPaymentChannel);
    if (selectedStatus) params.append("status", selectedStatus);

    if (dateRange.startDate) params.append("startDate", dateRange.startDate);
    if (dateRange.endDate) params.append("endDate", dateRange.endDate);

    if (search.trim()) params.append("search", search.trim());

    console.log("FINAL REQUEST:", `/Payment/GetAllPaymentHistory?${params.toString()}`);

    const { data } = await apiCall().get(`/Payment/GetAllPaymentHistory?${params.toString()}`);

    const sortedItems = (data?.reportItems ?? []).sort(
      (a: { PaymentDate: string | number | Date; }, b: { PaymentDate: string | number | Date; }) => new Date(b.PaymentDate).getTime() - new Date(a.PaymentDate).getTime()
    );

    return {
      reportItems: sortedItems,
      TotalCount: data.TotalCount,
      PageCount: data.PageCount
    };
  };


  const { data, isLoading, isFetching } = useQuery<{
    reportItems: TransactionItem[];
    TotalCount: number;
    PageCount: number;
  }>(
    [
      "transactions",
      pageNumber,
      pageSize,
      search,
      selectedStatus,
      selectedPaymentChannel,
      selectedPaymentAction,
      dateRange.startDate,
      dateRange.endDate,
    ],
    fetchTransactions,
    { keepPreviousData: true }
  );

  const totalCount = data?.TotalCount || 0;
  const pageCount = data?.PageCount || 1;
  const transactions = data?.reportItems || [];

  // RESET FILTERS
  const resetFilters = () => {
    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 3);

    setSelectedPaymentChannel("");
    setSelectedStatus("");
    setSelectedPaymentAction("Exam");

    setDateRange({
      startDate: start.toISOString().split("T")[0],
      endDate: end.toISOString().split("T")[0]
    });

    setSearch("");
    setPageNumber(1);
  };

  // 🔹 Download Report
  const { mutate: downloadReport, isLoading: isDownloading } = useMutation({
    mutationFn: async () => {
      const url = `/Payment/DownloadAllPaymentHistory?paymentChannel=${selectedPaymentChannel}&paymentAction=${selectedPaymentAction}&status=${selectedStatus}&startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`;
      return await downloadApi(url, "POST", JSON.stringify({}), {}, true);
    },
    onSuccess: (data) => {
      if (data) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "exam-transaction-report.xlsx");
        document.body.appendChild(link);
        link.click();

        set_notification({ type: "success", message: "Downloaded Successfully" });
        set_Nopen(true);
      } else {
        set_notification({ type: "error", message: "Error occurred while downloading file" });
        set_Nopen(true);
      }
    }
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Box>
          <TopDisplay
            label="Transaction History"
            button_array={[
              <Button
                variant="outline"
                color="var(--white-color)"
                bg="var(--dark-green-color)"
                leftIcon={<DownIcon />}
                onClick={() => downloadReport()}
                disabled={isDownloading}
              >
                {isDownloading ? "Downloading..." : "Download Transaction History Report"}
              </Button>
            ]}
          />

          {/* 🔍 Filters */}
          <Flex gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.300" />
              </InputLeftElement>

              <Input
                size="sm"
                placeholder="Search by Reference or Student No"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPageNumber(1);
                }}
              />

              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  cursor: "pointer",
                  top: "12px"
                }}
                onClick={() => {
                  setSearch('');
                  setPageNumber(1);
                }}
              >
                <ReloadIcon />
              </span>
            </InputGroup>

            <Select
              placeholder="Channel"
              width="130px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
              onChange={(e) => {
                setSelectedPaymentChannel(e.target.value);
                setPageNumber(1);
              }}
            >
              <option value="CyberPay">CyberPay</option>
              <option value="Interswitch">Interswitch</option>
              <option value="Deposit">Deposit</option>
              <option value="Other">Other</option>
            </Select>

            <Select
              placeholder="Payment Purpose"
              width="160px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
              onChange={(e) => {
                setSelectedPaymentAction(e.target.value);
                setPageNumber(1);
              }}
            >
              {paymentActionList.map((eType) => (
                <option key={eType} value={eType}>
                  {eType}
                </option>
              ))}
            </Select>

            <Select
              placeholder="Status"
              width="130px"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                setPageNumber(1);
              }}
            >
              <option value="Unknown">Unknown</option>
              <option value="Successful">Successful</option>
              <option value="Failed">Failed</option>
            </Select>

            <DateFilter text="Date Range" onChange={setDateRange} />

            <Button
              onClick={resetFilters}
              variant="outline"
              color="var(--white-color)"
              bg="var(--dark-green-color)"
            >
              Reset Filters
            </Button>
          </Flex>

          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">
              All Transactions
            </Heading>
            <Text fontSize=".8rem">
              Showing {(pageNumber - 1) * pageSize + 1}–
              {Math.min(pageNumber * pageSize, totalCount)} of {totalCount} records
            </Text>
          </Flex>

          {isFetching ? (
            <Text mt="10px" color="green">
              Loading transactions...
            </Text>
          ) : transactions.length > 0 ? (
            <TableContainer mt="20px">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th sx={HeadStyle}>Reference</Th>
                    <Th sx={HeadStyle}>MerchantRef</Th>
                    <Th sx={HeadStyle}>ApplicantId</Th>
                    <Th sx={HeadStyle}>FullName</Th>
                    <Th sx={HeadStyle}>Channel</Th>
                    <Th sx={HeadStyle}>Phone</Th>
                    <Th sx={HeadStyle}>Email</Th>
                    <Th sx={HeadStyle}>Date</Th>
                    <Th sx={HeadStyle}>Amount</Th>
                    <Th sx={HeadStyle}>Purpose</Th>
                    <Th sx={HeadStyle}>Status</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {transactions.map((item) => (
                    <ROWSTYLE key={item.PaymentHistoryId}>
                      <Td sx={DataStyle}>{item.PaymentReference || "N/A"}</Td>
                      <Td sx={DataStyle}>{item.MerchantReference || "N/A"}</Td>
                      <Td sx={DataStyle}>{item.ApplicantId}</Td>
                      <Td sx={DataStyle}>{item.FullName || "N/A"}</Td>
                      <Td sx={DataStyle}>{item.PaymentChannel}</Td>
                      <Td sx={DataStyle}>{item.CustomerPhone}</Td>
                      <Td
                        sx={{
                          ...DataStyle,
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        title={item.CustomerEmail || ""}
                      >
                        {item.CustomerEmail}
                      </Td>
                      <Td sx={DataStyle}>
                        {item.PaymentDate
                          ? format(new Date(item.PaymentDate), "dd/MM/yyyy")
                          : "N/A"}
                      </Td>
                      <Td sx={DataStyle}>{item.Amount}</Td>
                      <Td sx={DataStyle}>{item.PaymentAction}</Td>
                      <Td sx={DataStyle}>{item.PaymentStatus}</Td>
                    </ROWSTYLE>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          ) : (
            <Text mt="10px">No Transaction Found</Text>
          )}

          {pageCount > 1 && (
            <StylePaginateBox>
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={({ selected }) => setPageNumber(selected + 1)}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="<"
                forcePage={pageNumber - 1}
              />
            </StylePaginateBox>
          )}
        </Box>
      )}
    </>
  );
}




const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

  // const DownloadSchema = Yup.object({});

//   const ViewDownloadReport = (props:any) =>{
//   const [,set_open] = useAtom(openAtom);
//   const [,set_Nopen] = useAtom(openNAtom);
//   const [,set_notification]= useAtom(notificationAtom);
  
 
//   const {mutate:addUpdate,isLoading} = useMutation({
//     mutationKey:[],
//     mutationFn:async (exam:string)=> {
//       const headers = {
//         "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//       };
//       return await apiCall().get(`/Payment/DownloadAllPaymentHistory?paymentChannel&paymentAction=${"exam"}`,{
//         headers,
//         responseType:"blob"

//       })},
//     onSuccess:async(data:any)=>{
//       //initial the download 
//       console.log(data,'download data')
//       let file = data?.data;
//       console.log(file,'download file');
//       if(file){
//         const url = window.URL.createObjectURL(new Blob([file]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", "template.xlsx");
//         document.body.appendChild(link);
//         link.click();
//         console.log(file,'data')
//         set_notification({
//           type:'success',
//           message:data?.data?.Message || 'download Successfully'
//         })
//         set_Nopen(true);
//       }
//       else{
//         set_notification({
//           type:'error',
//           message:'Oooops! Error Occured trying to download Report'
//         })
//         set_Nopen(true);
//       }
      
      
      
//     },
//     onError(error:any, variables, context) {
//       set_notification({
//         type:'error',
//         message:error?.data?.Message || 'Error Occured'
//       })
//       set_Nopen(true);
//     },
//     onSettled:()=>{
//       set_open(false);
//     }

//   } )
//   return (
//     <>
//       <Formik
//           initialValues={{
            
//           }}
//           validationSchema={DownloadSchema}
//           onSubmit={(values:any) => {
//               if(values.Type){
//                 addUpdate(values.Type);
//               }

//           }}
//         >
//           {(formik:any)=>{
//         const {errors} = formik;
//         return (
//             <Form>
//               <Flex>
//                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
//                     {isLoading?"Loading":'Submit'}
//                 </Button>
//               </Flex>
//             </Form>
//           )}}
//         </Formik>
//     </>
//   )
// }

  // const DownloadSchema = Yup.object({});

//   const ViewDownloadReport = (props:any) =>{
//   const [,set_open] = useAtom(openAtom);
//   const [,set_Nopen] = useAtom(openNAtom);
//   const [,set_notification]= useAtom(notificationAtom);
  
 
//   const {mutate:addUpdate,isLoading} = useMutation({
//     mutationKey:[],
//     mutationFn:async (exam:string)=> {
//       const headers = {
//         "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//       };
//       return await apiCall().get(`/Payment/DownloadAllPaymentHistory?paymentChannel&paymentAction=${"exam"}`,{
//         headers,
//         responseType:"blob"

//       })},
//     onSuccess:async(data:any)=>{
//       //initial the download 
//       console.log(data,'download data')
//       let file = data?.data;
//       console.log(file,'download file');
//       if(file){
//         const url = window.URL.createObjectURL(new Blob([file]));
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute("download", "template.xlsx");
//         document.body.appendChild(link);
//         link.click();
//         console.log(file,'data')
//         set_notification({
//           type:'success',
//           message:data?.data?.Message || 'download Successfully'
//         })
//         set_Nopen(true);
//       }
//       else{
//         set_notification({
//           type:'error',
//           message:'Oooops! Error Occured trying to download Report'
//         })
//         set_Nopen(true);
//       }
      
      
      
//     },
//     onError(error:any, variables, context) {
//       set_notification({
//         type:'error',
//         message:error?.data?.Message || 'Error Occured'
//       })
//       set_Nopen(true);
//     },
//     onSettled:()=>{
//       set_open(false);
//     }

//   } )
//   return (
//     <>
//       <Formik
//           initialValues={{
            
//           }}
//           validationSchema={DownloadSchema}
//           onSubmit={(values:any) => {
//               if(values.Type){
//                 addUpdate(values.Type);
//               }

//           }}
//         >
//           {(formik:any)=>{
//         const {errors} = formik;
//         return (
//             <Form>
//               <Flex>
//                 <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
//                     {isLoading?"Loading":'Submit'}
//                 </Button>
//               </Flex>
//             </Form>
//           )}}
//         </Formik>
//     </>
//   )
// }




// export default function TransanctionHistory() {
//   const [hide,set_hide] = useState<boolean>(true);
//   const [activeIndex] = useAtom(indexAtom);
//   const [,set_open] = useAtom(openAtom);
//   const [,set_modal] = useAtom(modalAtom);
//   const [,set_Nopen] = useAtom(openNAtom);
//   const [,set_notification]= useAtom(notificationAtom);
//   const [Selected_payment_channel, set_selected_payment_channel] = useState<string>('');
//   const [selected_status, set_selected_status] = useState<string>('');
//   const [selected_payment_action, set_selected_payment_action] = useState<string>('');
//   const [date_range, set_date_range] = useState<{ startDate: string; endDate: string }>({
//     startDate: '',
//     endDate: '',
//   });

  
//   const paymentAction = useMemo(() => ['Exam Fee', 'Exam Subscription', 'Exam Induction','Exam Transcript',], []);


// const [pageNumber, setPageNumber] = useState(1);
// const [pageSize] = useState(100);
// const [pageCount, setPageCount] = useState(0);
// const [totalCount, setTotalCount] = useState(0);


// const { data: all_Exam_payment_history = [], isLoading } = useQuery(
//   ['get-all-payment-history', Selected_payment_channel, selected_status, selected_payment_action, date_range, pageNumber],
//   async () => {
//     const params = {
//       pageNumber,
//       pageSize,
//       channel: Selected_payment_channel?.toLowerCase() || undefined,
//       status: selected_status || undefined,
//       paymentAction: selected_payment_action || undefined,
//      startDate: date_range?.startDate || undefined,
//      endDate: date_range?.endDate || undefined,

//     };

//     const response = await apiCall().get(`Payment/GetAllPaymentHistory`, { params });

//     setTotalCount(response.data.TotalCount || 0);
//     setPageCount(Math.ceil((response.data.TotalCount || 0) / pageSize));

//     //console.log("Fetched Data →", response.data.reportItems); 

//     return response.data.reportItems;
//   },
//   {
//     keepPreviousData: true,
//   }
// );


//   const [search,set_search] = useState('');

//   const [filter_data,set_filter_data] = useState<any>(all_Exam_payment_history);
  
//   const handleSearch = (e:any)=>{
//     let val = e.target.value;
//     set_search(val);
//     if(val){
//       let new_data = all_Exam_payment_history?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      
//       set_filter_data(new_data)
//     }
//     else set_filter_data(all_Exam_payment_history)
//   }


//   const handlePageClick = ({ selected }: { selected: number }) => {
//     setPageNumber(selected + 1);
//   };


// useEffect(() => {
//   let data = all_Exam_payment_history ?? [];

//   if (Selected_payment_channel) {
//    data = data.filter((item: any) =>
//   item?.PaymentChannel?.toLowerCase() === Selected_payment_channel.toLowerCase()
// );

//   }

//   if (selected_status) {
//     data = data.filter((item: any)=>
//         item?.PaymentStatus?.toLowerCase() === selected_status.toLowerCase()
//     );
//   }

//   if (selected_payment_action) {
//     data = data.filter((item: any)=>
//         item?.PaymentAction?.toLowerCase() === selected_payment_action.toLowerCase()
//     );
//   }

//   if (date_range?.startDate && date_range?.endDate) {
//     const start = new Date(date_range.startDate);
//     const end = new Date(date_range.endDate);

//     data = data.filter((item: { CreatedAt: any; PaymentDate: any; }) => {
//       const dateStr = item?.CreatedAt || item?.PaymentDate;
//       const itemDate = new Date(dateStr);
//       return itemDate >= start && itemDate <= end;
//     });
//   }

//   set_filter_data(data);
// }, [
//   all_Exam_payment_history,
//   Selected_payment_channel,
//   selected_status,
//   selected_payment_action,
//   date_range,
// ]);